import currency from 'currency.js'

const EURO = (value) =>
  currency(value, { symbol: '€ ', decimal: ',', separator: '.' })

export default EURO
